'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import Image from 'next/image';
import 'swiper/css';
import 'swiper/css/pagination';
import styles from './slider.module.scss';
import { ManagementSliderProps } from '@/types/managementSlider.types';

const ManagementSlider = ({ slides }: ManagementSliderProps) => {
  return (
    <section className="container">
      <div className={styles.sliderWrapper}>
        <style jsx global>{`
          .swiper-pagination {
            position: absolute;
            bottom: -40px !important;
            left: 0;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .swiper-pagination-bullet {
            width: 19px;
            height: 4px;
            background: #d9d9d9;
            opacity: 1;
            margin: 0 6px;
            cursor: pointer;
            border-radius: 6px;
          }
          .swiper-pagination-bullet-active {
            background: #4d535f;
            width: 48px;
            height: 4px;
          }
        `}</style>
        <Swiper
          modules={[Pagination]}
          pagination={{
            clickable: true,
          }}
          spaceBetween={30}
          slidesPerView={1.3}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 8,
            },
            360: {
              slidesPerView: 1.2,
              spaceBetween: 8,
            },
            480: {
              slidesPerView: 1.6,
              spaceBetween: 16,
            },
            576: {
              slidesPerView: 2.2,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: 3.2,
              spaceBetween: 24,
            },
            1160: {
              slidesPerView: 4.2,
              spaceBetween: 24,
            },
          }}
          className={styles.swiper}
        >
          {slides.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div className={styles.slide}>
                <div className={styles.imageWrapper}>
                  <Image
                    src={slide.image}
                    alt="Management"
                    width={272}
                    height={268}
                  />
                  <div className={styles.content}>
                    <h4 className={styles.name}>{slide.name}</h4>
                    <p className={styles.position}>{slide.position}</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ManagementSlider;
